import { Environment } from '@abp/ng.core';

const baseUrl = window.location.origin;

export const environment = {
  production: true,
  hmr: false,
  application: {
    baseUrl,
    name: 'LiveChat',
  },
  oAuthConfig: {
    issuer: '/livechat-auth',
    redirectUri: baseUrl,
    clientId: 'LiveChat_App',
    responseType: 'code',
    requireHttps: false,
    scope: 'offline_access LiveChat',
    skipIssuerCheck: true,
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    impersonation: {
      userImpersonation: true,
      tenantImpersonation: true,
    },
  },
  apis: {
    default: {
      url: '',
      rootNamespace: 'LiveChat',
    },
  },
} as Environment;
